/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} IndicaInputs */

const en_indica = /** @type {(inputs: IndicaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indica`)
};

const th_indica = /** @type {(inputs: IndicaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อินดิก้า`)
};

const ja_indica = /** @type {(inputs: IndicaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インディカ`)
};

const fr_indica = /** @type {(inputs: IndicaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indica`)
};

const es_indica = /** @type {(inputs: IndicaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indica`)
};

const ru_indica = /** @type {(inputs: IndicaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индика`)
};

const zh_indica = /** @type {(inputs: IndicaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印度大麻`)
};

const vi_indica = /** @type {(inputs: IndicaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indica`)
};

/**
* | output |
* | --- |
* | "Indica" |
*
* @param {IndicaInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const indica = /** @type {((inputs?: IndicaInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<IndicaInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_indica(inputs)
	if (locale === "ja") return ja_indica(inputs)
	if (locale === "fr") return fr_indica(inputs)
	if (locale === "es") return es_indica(inputs)
	if (locale === "ru") return ru_indica(inputs)
	if (locale === "zh") return zh_indica(inputs)
	if (locale === "vi") return vi_indica(inputs)
	return en_indica(inputs)
});